// 📄 components/StepPOPartner.tsx
import React from 'react';
import { AlertCircle } from 'lucide-react';
import { PurchaseOrderFormData } from '../../../../../services/commerce/integrationService';

interface StepPOPartnerProps {
  partnerNumber: string;
  partnerType: string;
  outboundPort: string;
  onChange: (field: keyof PurchaseOrderFormData, value: any) => void;
  isInvalid: boolean;
}

export function StepPOPartner({ partnerNumber, partnerType, outboundPort, onChange, isInvalid }: StepPOPartnerProps) {
  return (
    <div className="space-y-4 animate-fadeIn">
      {/* SPRO Route */}
      <div className="bg-blue-500/5 border border-blue-500/10 rounded-xl p-3 mb-2 space-y-1">
        <span className="text-[10px] font-bold text-blue-400 uppercase tracking-widest block">Ruta SPRO / Transacción SAP</span>
        <p className="font-mono text-xs text-gray-300">
          <span className="bg-zinc-800 px-1.5 py-0.5 rounded text-gray-400 font-bold mr-1.5">WE20 / WE21</span> 
          <span>SAP Menu → Tools → ALE → ALE Administration → Runtime Settings → Partner Profile</span>
        </p>
      </div>

      <div>
        <h3 className="text-lg font-medium text-blue-400">2. Partner Profile & Port Definition (Interlocutor y Puerto)</h3>
        <p className="text-sm text-gray-400">
          Configura el Partner Profile en la transacción <code className="bg-black/30 px-1 rounded">WE20</code> y el puerto lógico de salida para dirigir el IDoc de orden de compra (`ORDERS`) a SAP Ariba.
        </p>
      </div>

      <div className="bg-white/5 p-4 rounded-xl border border-white/5 grid grid-cols-1 md:grid-cols-3 gap-4">
        <div>
          <label className="block text-xs font-medium text-gray-400 mb-1">
            Número de Interlocutor (Partner No.) <span className="text-red-400">*</span>
          </label>
          <input
            type="text"
            value={partnerNumber}
            onChange={(e) => onChange('partnerNumber', e.target.value.toUpperCase())}
            placeholder="ej. ARIBA_CIG"
            className={`w-full bg-zinc-800 border rounded-lg p-2.5 text-sm font-mono text-white focus:outline-none focus:border-blue-500 ${
              isInvalid && !partnerNumber ? 'border-red-500' : 'border-white/10'
            }`}
          />
        </div>

        <div>
          <label className="block text-xs font-medium text-gray-400 mb-1">Tipo de Interlocutor (Partner Type)</label>
          <select
            value={partnerType}
            onChange={(e) => onChange('partnerType', e.target.value)}
            className="w-full bg-zinc-800 border border-white/10 rounded-lg p-2.5 text-sm text-white focus:outline-none focus:border-blue-500"
          >
            <option value="LS">LS - Logical System (Sistema lógico)</option>
            <option value="KU">KU - Customer (Cliente)</option>
            <option value="LI">LI - Vendor (Proveedor)</option>
          </select>
        </div>

        <div>
          <label className="block text-xs font-medium text-gray-400 mb-1">
            Puerto de Salida (Outbound Port) <span className="text-red-400">*</span>
          </label>
          <input
            type="text"
            value={outboundPort}
            onChange={(e) => onChange('outboundPort', e.target.value.toUpperCase())}
            placeholder="ej. A000000001"
            className={`w-full bg-zinc-800 border rounded-lg p-2.5 text-sm font-mono text-white focus:outline-none focus:border-blue-500 ${
              isInvalid && !outboundPort ? 'border-red-500' : 'border-white/10'
            }`}
          />
        </div>
      </div>

      <div className="bg-blue-500/10 border border-blue-500/20 rounded-xl p-4 text-blue-400 flex gap-3 text-sm">
        <AlertCircle className="w-5 h-5 flex-shrink-0" />
        <div>
          <p className="font-semibold">Parámetros Outbound del IDoc</p>
          <p className="text-xs text-blue-400/80 mt-0.5">
            Recuerde agregar la entrada en la tabla de parámetros de salida (Outbound Options) para el tipo de mensaje <code className="bg-black/30 px-1 rounded">ORDERS</code> con el tipo básico de IDoc <code className="bg-black/30 px-1 rounded">ORDERS05</code> en la transacción <code className="bg-black/30 px-1 rounded">WE20</code>.
          </p>
        </div>
      </div>
    </div>
  );
}
